import React from 'react';
import Footer from "./Footer";

const Affiliation = () => {
    return (
        <div className="container">
            <h1 className="page-header">Institutional Affiliations</h1>
            <div className="col-md-8 col-xs-12">
                <h3><a href="https://tandt.cah.ucf.edu/">University of Central Florida</a></h3>
                <p>UCF's <a href="https://tandt.cah.ucf.edu/">Texts and Technology Ph.D program</a> provides institutional support for the project and graduate study in the production and assessment of digital media texts.</p>
                <hr />
                <h3><a href="http://www.mla.org/rep_scholarly">Reports from the MLA Committee on Scholarly Editions</a></h3>
                <p><a href="http://www.mla.org/rep_scholarly">Reports from the MLA Committee on Scholarly Editions</a> provide editor and vetter guidelines for producing CSE volumes.</p>
                <hr />
                <h3><a href="http://www.tei-c.org/">Text Encoding Initiative</a></h3>
                <p><a href="http://www.tei-c.org/">TEI (Text Encoding Initiative) Consortium</a> develops and maintains standards for optimal encoding of textual materials.</p>                <p>If you prefer to donate by mail, you can send a check made payable to “UCF Foundation, Inc.” with “Humanities Center” in the memo line to the address to the right.</p>
                <hr />
                <h3><a href="https://nines.org/">NINES</a></h3>
                <p><a href="https://nines.org/">NINES — A Networked Interface for Nineteenth-Century Electronic Scholarship</a> — is a collective of scholars interested in promoting a publishing environment for integrated, peer-reviewed electronic scholarship </p>
                <hr />
                <h3><a href="https://brockdenbrownsociety.ucf.edu/">The Charles Brockden Brown Society</a></h3>
                <p><a href="https://brockdenbrownsociety.ucf.edu/">The Charles Brockden Brown Society</a> is an international scholarly organization of scholars interested in researching and discussing Brown and the culture, history, and literature of the Atlantic world of the late eighteenth and early nineteenth centuries. </p>
            </div>
            <Footer />
        </div>
    );
};
export default Affiliation;
